var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 1.05206C10.9995 1.03479 11 1.01746 11 1C11 0.447693 10.5523 0 10 0C9.44776 0 9.00001 0.447693 9.00001 1C9.00001 1.01746 9.0005 1.03485 9.00135 1.05212C5.6537 1.53461 2.50367 5.2995 3.00001 9.5C3.25709 10.7854 2.44764 11.4664 1.60511 12.1752C0.808969 12.845 -0.0165922 13.5396 0.000253527 14.7925C0.000253527 16.5484 1.00001 17.5 2.46827 17.9719C2.46827 17.9719 5.15736 19 10.0001 19C14.8429 19 17.532 17.9719 17.532 17.9719C19.0003 17.5 20.0003 16.5 20 14.7925C19.9999 13.5288 19.1748 12.8339 18.3831 12.1672C17.5443 11.4609 16.7431 10.7861 17.0003 9.5C17.4966 5.29938 14.3464 1.53442 10.9987 1.05206Z",
    fill: "#46BE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42738 20.2C5.98548 20.5314 5.89601 21.1581 6.2273 21.6C8.12733 24.1334 11.9274 24.1334 13.8274 21.6C14.1587 21.1581 14.0692 20.5314 13.6273 20.2C13.1856 19.8687 12.5587 19.9582 12.2273 20.4C11.1273 21.8666 8.92738 21.8666 7.8274 20.4C7.49598 19.9582 6.86915 19.8687 6.42738 20.2Z",
    fill: "#46BE60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.aa62bcda.svg";
export { ForwardRef as ReactComponent };